import axios from 'axios';
import Common from './Common';
export default {
    getMyEstimations(id) {
        return axios.get(Common.api + 'get-my-estimation-all/' + id);
    },
    getMyTradings(id) {
        return axios.get(Common.api + 'get-my-tradings-all/' + id);
    },
    getMyCompletes(id) {
        return axios.get(Common.api + 'get-my-completed-all/' + id);
    },
    createResgistration2(data) {
        return axios.post(Common.api + 'buyer-reg-second', data);
    },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    }
}